import { readonly, Ref, ref } from 'vue'

import { createTimer } from '@collector/shared-utils'

export type UseTimer = {
  elapsedSeconds: Readonly<Ref<number>>
  minute: Readonly<Ref<number>>
  second: Readonly<Ref<number>>
  setMinute(value: number): void
  setSecond(value: number): void
  /**
   * Start counting seconds.
   */
  startTimer(): void
  /**
   * Stop counting seconds.
   */
  stopTimer(): void
  /**
   * Clear already counted seconds.
   */
  clearElapsedSeconds(): void
}

export function useTimer(): UseTimer {
  const { startTimer: _startTimer, stopTimer } = createTimer()

  // state
  const elapsedSeconds = ref(0)
  const minute = ref(0)
  const second = ref(0)

  // methods
  function startTimer(): void {
    _startTimer((ticks) => {
      elapsedSeconds.value += ticks
    })
  }

  function clearElapsedSeconds(): void {
    elapsedSeconds.value = 0
  }

  function setMinute(value: number): void {
    minute.value = value
  }

  function setSecond(value: number): void {
    second.value = value
  }

  return {
    elapsedSeconds: readonly(elapsedSeconds),
    minute: readonly(minute),
    second: readonly(second),
    setMinute,
    setSecond,
    startTimer,
    stopTimer,
    clearElapsedSeconds,
  }
}
